<template>
  <div>
    <!-- <v-menu
        :close-on-content-click="false"
        v-model="dateMenu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        >
            <v-text-field
            slot="activator"
            label="* Date" 
            color="indigo"
            type="date"
            prepend-icon="date_range"
            v-model="date"
            :rules="dateRules"
            >
            </v-text-field>
            <v-date-picker 
            v-model="date" 
            @input="dateMenu = false" 
            :color="$store.state.global.pages.docket.color"
            ></v-date-picker>
    </v-menu>-->
    <v-menu
      ref="dateMenu"
      :close-on-content-click="false"
      v-model="dateMenu"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
      :disabled="disabled"
    >
      <v-text-field
        slot="activator"
        ref="dateField"
        :color="color"
        :rules="!!rules ? rules : dateRules"
        :value="value"
        @input="fieldInput"
        :label="label"
        type="date"
        :disabled="disabled"
        :prepend-icon="!noIcon ? 'date_range' : null"
        clearable
      ></v-text-field>
      <v-date-picker scrollable :color="color" :value="value" @input="pickerInput" full-width></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateMenu: false,
      dateRules: [(v) => !!v || 'Field is required'],
    }
  },
  props: {
    value: String,
    label: String,
    color: String,
    rules: Array,
    noIcon: Boolean,
    disabled: Boolean,
  },
  methods: {
    pickerInput(val) {
      this.$emit('input', val)
      this.dateMenu = false
    },
    fieldInput(val) {
      this.$emit('input', val)
      this.dateMenu = false
    },
    toggleTimePicker() {
      this.dateMenu = !this.dateMenu
    },
  },
}
</script>

<style>
</style>
